import React, { useContext } from 'react'
import RSRLMultipleBar from './RSRLMultipleBar'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default props => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlIndicateursXlsxSatisfaction.edges
  const page = props.page

  const slug = useContext(AccordionContext)

  let labels = edges.map((row, i) => row.node.LABEL)
  let values1 = edges.map((row, i) => row.node.A)
  let values2 = edges.map((row, i) => row.node.B)
  let values3 = edges.map((row, i) => row.node.C)
  let values4 = edges.map((row, i) => row.node.D)

  let datasets = [
    {
      borderWidth: 0,
      stack: 'A',
      label: "Tout à fait d'accord",
      data: values1,
      backgroundColor: '#f2e6ee',
    },
    {
      borderWidth: 0,
      stack: 'B',
      label: "Plutôt d'accord",
      data: values2,
      backgroundColor: '#d3adc7',
    },
    {
      borderWidth: 0,
      stack: 'C',
      label: "Plutôt pas d'accord",
      data: values3,
      backgroundColor: '#9b005b',
    },
    {
      borderWidth: 0,
      stack: 'D',
      label: "Pas du tout d'accord",
      data: values4,
      backgroundColor: '#707070',
    },
  ]

  return (
    <div className="text-content accordion-content accordion-table">
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <RSRLMultipleBar
        key={slug}
        labels={labels}
        datasets={datasets}
        ylabel={'% Personnes'}
        xlabel={'N=38'}
      />
      <div
        className="afterCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    </div>
  )
}

const query = graphql`
  query {
    allRsrlIndicateursXlsxSatisfaction {
      edges {
        node {
          LABEL
          A
          B
          C
          D
        }
      }
    }
  }
`
